// src/utils/problemColumnDefs.ts
import { ColDef } from "ag-grid-community";
import { ProblemData } from "./problemTypes"; // create and import the type
const isAdmin = localStorage.getItem("isAdmin") === "true";
const isSuperAdmin = localStorage.getItem("superadmin") === "true";

const formatDateUTC3 = (date: Date | string | null): string => {
  if (!date) return "";

  const d = typeof date === "string" ? new Date(date.replace(" ", "T")) : date;

  return d.toLocaleString("en-GB", {
    timeZone: "Etc/GMT-3", // ✅ corrected
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
};
const getColumnDefs = (
  handleEdit: (data: ProblemData) => void,
  handleDelete: (ticketId: string) => void,
): ColDef<ProblemData>[] => [
  {
    field: "ticketId",
    headerName: "Ticket ID",
    pinned: "left",
  },

  { field: "status", headerName: "Status", filter: "agMultiColumnFilter" },
  { field: "affectedCustomer", headerName: " Customer" },
  { field: "affectedNetwork", headerName: " Network" },
  { field: "affectedSite", headerName: " Site" },
  { field: "affectedLink", headerName: " Link" },
  { field: "asset", headerName: "Asset" },
  {
    field: "timeElapsed",
    headerName: "Time Elapsed",
    filter: "agNumberColumnFilter",
    cellRenderer: (params: any) => {
      const timeElapsed = params.data.timeElapsed || 0;
      const isOver100 = timeElapsed > 100;

      return (
        <div
          style={{ display: "flex", alignItems: "center", fontWeight: "bold" }}
        >
          {isOver100 ? (
            <>
              <i
                className="fa fa-exclamation-circle"
                style={{ color: "red", marginLeft: "8px" }}
              />
              <span style={{ color: "red" }}>{timeElapsed}%</span>
            </>
          ) : (
            <>
              <i
                className="fa fa-check-circle"
                style={{ color: "green", marginLeft: "8px" }}
              />
              <span style={{ color: "green" }}>{timeElapsed}%</span>
            </>
          )}
        </div>
      );
    },
  },
  {
    field: "summary",
    headerName: "Summary",
    valueFormatter: (params: { value: string }) => {
      const div = document.createElement("div");
      div.innerHTML = params.value;
      return div.textContent || div.innerText || "";
    },
  },
  {
    field: "description",
    headerName: "Description",
    valueFormatter: (params: { value: string }) => {
      const div = document.createElement("div");
      div.innerHTML = params.value;
      return div.textContent || div.innerText || "";
    },
  },
  {
    field: "solution",
    headerName: "Solution",
    valueFormatter: (params: { value: string }) => {
      const div = document.createElement("div");
      div.innerHTML = params.value;
      return div.textContent || div.innerText || "";
    },
  },
 {
  field: "problemStartDatetime",
  headerName: "Problem Start Date/Time",
  filter: "agDateColumnFilter",

  valueFormatter: (params: any) =>
    params.value ? params.value.replace("T", " ") : "",

  filterValueGetter: (params: any) => {
    const raw = params.data?.problemStartDatetime;
    return raw ? new Date(raw.replace(" ", "T")) : null;
  },
},
{
  field: "problemCloseDatetime",
  headerName: "Problem End Date/Time",
  filter: "agDateColumnFilter",

  valueFormatter: (params: any) =>
    params.value ? params.value.replace("T", " ") : "",

  filterValueGetter: (params: any) => {
    const raw = params.data?.problemCloseDatetime;
    return raw ? new Date(raw.replace(" ", "T")) : null;
  },
},
  { field: "problemResolutionTime", headerName: "problem Resolution Time" },
  { field: "responsibleTeam", headerName: "Responsible Team" },
  { field: "responsiblePerson", headerName: "Responsible Person" },
  { field: "impact", headerName: "Impact" },
  { field: "urgency", headerName: "Urgency" },
  { field: "priority", headerName: "Priority" },
  {
    field: "createdby",
    headerName: "Created By",
  },
  { field: "closedby", headerName: "Closed by" },
  { field: "closureCode", headerName: "Closure Code" },
  { field: "errorType", headerName: "Error Type" },
  {
    field: "ticketCreationDatetime",
    headerName: "Ticket Creation Date/Time",
    filter: "agDateColumnFilter",
    valueFormatter: (params: any) => formatDateUTC3(params.value),
    filterValueGetter: (params: any) => {
      const raw = params.data?.ticketCreationDatetime;
      return raw ? new Date(raw.replace(" ", "T")) : null;
    },
    sort: "desc",
    sortIndex: 1,
  },
  {
    field: "ticketClosureDatetime",
    headerName: "Ticket Closure Date/Time",
    filter: "agDateColumnFilter",
    valueFormatter: (params: any) => formatDateUTC3(params.value),
    filterValueGetter: (params: any) => {
      const raw = params.data?.ticketClosureDatetime;
      return raw ? new Date(raw.replace(" ", "T")) : null;
    },
  },

  { field: "sla", headerName: "SLA" },
  { field: "slaStatus", headerName: "SLA Status" },

  { field: "relatedobject", headerName: "Related Object" },
  {
    colId: "actions",
    headerName: "Actions",
    cellRenderer: (params: any) => (
      <div style={{ display: "flex", gap: "8px" }}>
        <button onClick={() => handleEdit(params.data)}>Edit</button>
        {isSuperAdmin && (
          <button onClick={() => handleDelete(params.data.ticketId)}>
            Delete
          </button>
        )}
      </div>
    ),
    pinned: "right",
    flex: 1,
  },
];

export default getColumnDefs;
